export default "__VITE_ASSET__BzVJxB8Q__"